export const propagateContactDataToAddress = (address, contact) => {
    return {
        ...address,
        firstname: contact.firstname ?? "",
        lastname: contact.lastname ?? "",
        telephone: contact.telephone ?? "",
    };
};
//# sourceMappingURL=propagateContactDataToAddress.js.map